@if (alerts$ | async; as alerts) {
  <div class="alerts" [ngClass]="{ sticky: sticky }">

    @for (alert of alerts; track alert.message) {
      <ngb-alert id="close-button"
                 (closed)="removeAlert(alert)"
                 [type]="alert.type">

        @if (isSuccess(alert)) {
          <i class="vspicon-vsp_check_circle alert-icon"></i>
        }

        <span class="alert-span-dynamic-content"
              [innerHTML]="alert.message"></span>

        <span class="alert-span-style">
          <a [routerLink]="['contact-us']"
             routerLinkActive="active"
             id="retail-alert-contactUs">
            {{ alert.alertLink }}
          </a>
        </span>

        <span>
          {{ alert.code }}
        </span>

      </ngb-alert>
    }

  </div>
}
